import MayoLanding from "../common/MayoLanding";

import doctorImage from "../../../../assets/Mayo/lp_img.png";

export default function MayoLanding3() {
  return <MayoLanding
    title={"Welcome"}
    text={"Congratulations on completing your TAVR! Post-discharge, we’re here to guide you through your heart-health journey and empower you for optimal recovery."}
    image={doctorImage}
    buttonText={"Start"}
    navigateTo={"/patient/mayo/video_page3"}
    postAnalyticType="messageOpnedPostProcedure"
  />
}